<template>
    <div>
        <div class="flex flex-col space-y-1 p-1" v-if="allAccountingPostsVisible">
            <div class="flex flex-col" v-for="(post, idx) in engagement.accounting_posts" :key="post.id">
                <div class="flex">
                    <!-- {{ new Date(post.created_at).toLocaleDateString() }}: {{ post.post_body }} -->
                    {{ formatDateTwoDigitYear(post.created_at) }}: {{ post.post_body }}
                    <div class="px-1">
                        <button v-if="engagement.accounting_posts.length > 1 && idx === 0" class="text-xs flex items-center  px-0.5 rounded-full h-fit hover:text-white hover:bg-dark-primary" @click="setAccountingPostsVisibility(false)">^</button>
                    </div>
                </div>
                <div class="w-full border-b border-b-black" v-if="idx < engagement.accounting_posts.length - 1"></div>
            </div>
        </div>
        <div v-else-if="engagement.accounting_posts.length > 0">
            <div class="flex" >
                    <!-- {{ new Date(engagement.accounting_posts[0].created_at).toLocaleDateString() }}: {{ engagement.accounting_posts[0].post_body }}  -->
                    {{ formatDateTwoDigitYear(engagement.accounting_posts[0].created_at) }}: {{ engagement.accounting_posts[0].post_body }} 
                    <div class="px-1">
                        <button class="text-xs flex items-center px-0.5 rounded-full h-fit hover:text-white hover:bg-dark-primary" @click="setAccountingPostsVisibility(true)">⌄</button>
                    </div>
            </div>
        </div>
    </div>
    <div class="w-full text-center">
        <base-button @click="showPostsForm" class="w-1/2">+</base-button>
    </div>
    <base-modal :is-form-visible="postsFormVisible" @close="closePostsForm">
        <template #header>
            Accounting Posts 
        </template>
        <template #body>
            <EngagementAccountingPostForm :engagement="engagement" @refetch-engagements="fetchNewEngagements" />
        </template>
    </base-modal>
</template>

<script>
export default {
    name: "engagement-accounting-posts-cell"
}
</script>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { formatDateTwoDigitYear } from '@/composables/formatDate';
import EngagementAccountingPostForm from './EngagementAccountingPostForm.vue';

const allAccountingPostsVisible = ref(false)
const postsFormVisible = ref(false)

function showPostsForm() {
    postsFormVisible.value = true 
}

function closePostsForm() {
    postsFormVisible.value = false
}

const props = defineProps({
    engagement: Object
})

const emit = defineEmits(['refetch-engagements'])

function setAccountingPostsVisibility(target) {
    allAccountingPostsVisible.value = target 
}

function fetchNewEngagements(){
    emit('refetch-engagements')
}


</script>

